












import Vue from "vue";
import Component from "vue-class-component";
import { LatLng } from "leaflet";
import { LControl } from "vue2-leaflet";
import { targets, maps } from "@/store";
import coordsFormater from "@/utils/coords_formater";

const MouseCoordsDisplayProps = Vue.extend({
  props: {
    mouseCoords: {
      type: Object as () => LatLng,
    },
  },
});

@Component({
  components: {
    LControl,
  },
})
export default class MouseCoordsDisplay extends MouseCoordsDisplayProps {
  get aisTargetsCount() {
    return targets.getters.aisTargetsCount;
  }
  get mapZoom() {
    return maps.getters.mapZoom;
  }
  get coords() {
    return coordsFormater([this.mouseCoords.lng, this.mouseCoords.lat]);
  }
}
